/**
 * @generated SignedSource<<e481ce4489a496452f77cb85b58f9a86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CarryForwardBlocksMutation$variables = {
  noteId: string;
  type: string;
};
export type CarryForwardBlocksMutation$data = {
  readonly noteCarryForwardBlocks: {
    readonly note: {
      readonly actionItemsCarriedForward: boolean;
      readonly talkingPointsCarriedForward: boolean;
    };
  } | null;
};
export type CarryForwardBlocksMutation = {
  response: CarryForwardBlocksMutation$data;
  variables: CarryForwardBlocksMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "type"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "noteId",
    "variableName": "noteId"
  },
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "type"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actionItemsCarriedForward",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "talkingPointsCarriedForward",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CarryForwardBlocksMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NoteCarryForwardBlocks",
        "kind": "LinkedField",
        "name": "noteCarryForwardBlocks",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CarryForwardBlocksMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NoteCarryForwardBlocks",
        "kind": "LinkedField",
        "name": "noteCarryForwardBlocks",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ea240645095a6ac0cbf4a921dd218b49",
    "id": null,
    "metadata": {},
    "name": "CarryForwardBlocksMutation",
    "operationKind": "mutation",
    "text": "mutation CarryForwardBlocksMutation(\n  $noteId: ID!\n  $type: String!\n) {\n  noteCarryForwardBlocks(noteId: $noteId, type: $type) {\n    note {\n      actionItemsCarriedForward\n      talkingPointsCarriedForward\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c0b94a6305affb26281874656b2b4b56";

export default node;
